<div class="card-wrapper">
    <div class="order-card">  
        <div class="img-square-wrapper">
            <img  src="assets/icon/Product card image 3.svg" alt="product one">
        </div>         
    <div class="card mb-2">
        
        <div class="card-horizontal">
            
            <div class="card-body">
                <div class="newitem">
                    <div class="veg-newlaunch">
                        <div class="veg">
                            <img src="assets/icon/veg.png" alt="veg-item">
                        </div>
                        <div class="newlaunch">
                            <h6> <span class="badge badge-secondary">New Launch</span></h6>
    
                        </div>
                    </div>
                </div>
    
                <h3 class="card-title">{{data.product_name}}</h3>
                <h5 class="card-subtitle mb-2 text-muted">{{data.q_c}}</h5>
                <p class="card-text">
                     Aliquam bibendum congue turpis, vitae fringilla ipsum... 
                    </p>
    
            </div>
        </div>
        <div class="card-footer-custom">
            <div class="left-item">
                <h4>₹ {{data.price}}<span class="round-figure">.00</span></h4>
            </div>
            <div class="left-item" *ngIf="!editMode">
                <button type="button" class="custom-btn btn-green btn-sm-rounded">Add Item</button>
            </div>
            <div class="left-item" *ngIf="editMode">
                 <button type="button" (click)="removeItem(index)" class="custom-btn btn-red btn-sm-rounded">Remove</button>
            </div>
        </div>
    </div>
    </div>
</div>
